import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBuildConfig } from 'packages/buildConfig';

type ConfigState = {
  data: IBuildConfig | null;
};

const initialState: ConfigState = {
  data: null,
};

const CONFIG = 'CONFIG';

export const configSlice = createSlice({
  name: CONFIG,
  initialState,
  reducers: {
    setConfig: (state, { payload }: PayloadAction<ConfigState['data']>) => {
      state.data = payload;
    },
  },
});

export const configReducer = configSlice.reducer;
export const configActions = configSlice.actions;
